import {
  MergedProjectDto,
  PageContextOfProjectFilter,
  PaginatedDtoOfMergedProjectDto,
  SortDirections,
} from "app/ApiClient";
import { LoadingState } from "types";

export type ProjectsFilterType = {
  [key in keyof MergedProjectDto]?: (string | null)[];
};

export interface ProjectsState {
  data?: PaginatedDtoOfMergedProjectDto;
  projectsLoading: LoadingState;
  error?: string;
  pageContext: PageContextOfProjectFilter;
  creatingFromEncodedOriginProjectId?: string | null;
  filters?: ProjectsFilterType;
}

export const originProjectsState: ProjectsState = {
  projectsLoading: LoadingState.idle,
  pageContext: {
    page: { pageNumber: 1, pageSize: 10 },
    sortList: [{ directions: SortDirections.Desceding, field: "modifiedAt" }],
  },
};
